<template>
    <div>

        <rkm-area
            title="Cotas cadastradas"
        >
            <rkm-table
                :fields="fields"
                :items="exames"
                ref="Table"
                hide-filters
                sort-by="nome"
            >

                <template v-slot:cell(cota)="{ item }">
                    {{ formatQuantidade(item) }}
                </template>

                <template v-slot:cell(distribuida)="row">
                    {{ handleCotaAtribuida(row.item) }}
                </template>

                <template v-slot:cell(utilizada)="row">
                    {{ getUtilizada(row.item) }}
                </template>

                <template v-slot:cell(saldo)="row">
                    {{ getSaldo(row.item) }}
                </template>

                <template v-slot:cell(aDistribuir)="row">
                    {{ getCotaADistribuir(row.item) }}
                </template>

                <template v-slot:cell(actions)="{ index, item }">

                    <rkm-button
                        @click="openUnidadeSolicitante(index, item)"
                        color="info"
                        small
                        title="Unidade Solicitante"
                    >
                        <rkm-icon icon="door-closed" />
                    </rkm-button>

                    <rkm-button
                        @click.stop="$emit('handleAlter', index, item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        color="danger"
                        title="Excluir"
                        small
                        @click.stop="handleCota(index, item)"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>
                </template>

                <template v-slot:custom-foot>
                <tr>
                    <td class="table-td">
                        Total
                    </td>
                    <td class="table-td" v-if="cotaTipoId == enums.tipoCota.QUANTIDADE">
                        {{ formatMoney(examesum, 0) }}
                    </td>
                    <td class="table-td" v-if="cotaTipoId == enums.tipoCota.VALOR">
                        {{ formatMoney(examesum, 2) }}
                    </td>

                    <td class="table-td text-center">
                        {{ getCotaAtribuidaTotal() }}
                    </td>

                    <td class="table-td text-center">
                        {{ getCotaADistribuirTotal() }}
                    </td>

                    <td class="table-td text-center">
                        {{ getUtilizadaTotal() }}
                    </td>

                    <td class="table-td text-center">
                        {{ getSaldoTotal() }}
                    </td>
                    <td class="table-td"></td>
                </tr>
                </template>
            </rkm-table>
        </rkm-area>

        <Modal
            :data="data"
            :cotalaboratorio="cotalaboratorio"
            :indexExame="indexExame"
            ref="Modal"
            @save="save"
        />
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import Modal from './components/unidade-solicitante/Modal'

// Mixins.
import { repository, object, data, formats } from '@/mixins'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'

export default {
    components: { Modal },
    computed: {
        fields() {

            const fields = [
                { key: 'nome', label: 'Exame', sortable: true },
                { key: 'cota', label: 'Cota', class: 'col-min text-center', sortable: true },
                { key: 'distribuida', label: 'Distribuída', class: 'col-min text-center', sortable: true },
                { key: 'aDistribuir', label: 'A distribuir', class: 'col-min text-center', sortable: true },
                { key: 'utilizada', label: 'Utilizada', class: 'col-min text-center', sortable: true },
                { key: 'saldo', label: 'Saldo', class: 'col-min text-center', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min' },
            ]

            return fields
        },
    },
    created() {

        this.repositories = {
            saldo: this.getConectaSusRepository('exameLaboratorial.parametrizacao')
        }
    },
    data: () => ({
        items: [],
        model: {
            cotaValor: 0,
            saldo: 0,
            consumido: 0,
        },
        enums: {
            tipoCota,
        },
        cotasAtribuidas: 0,
        cotaAtribuida: 0,
        saldoAtribuidas: 0,
        utilizada: 0,
        utilizadas: 0,
        saldoUtilizadas: 0,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        openUnidadeSolicitante(index, item) {

           this.$refs.Modal.open(index, item)
        },
        handleCota(index, item) {

            this.setLoading()

            const data = this.cotalaboratorio

            this.repositories.saldo.saldoExame({
                unidade_id: data.unidadeId,
                infraestrutura_id: data.infraestruturaId,
                exame_id: item.exameId,
                inicio: data.periodo.start.split("/").reverse().join("-"),
                fim: data.periodo.end.split("/").reverse().join("-"),
            })
                .then(response => {

                    this.getCotaAtribuida(data, response.data, item)

                    if (this.utilizadas == 0 || this.utilizadas == '0,00') {

                    this.handleDestroy(index, item)

                    } else {

                    this.showValidationNotification(`Não é possível excluir o exame <strong>${ item.nome }</strong>, pois
                        já possui agendamentos vinculados a ele.`)

                    return false
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(index, item) {

            if (item.unidadeSolicitante.length > 0) {

                this.showValidationNotification(`Não é possível excluir o exame <strong>${ item.nome }</strong>, pois
                    já possui cotas atribuídas.`)

                return false
            }

            const destroy = async () => {

                const objIndex = this.exames.findIndex(obj => obj.exameId === item.exameId)

                this.exames.splice(objIndex, 1)

                this.$emit('checkSum')
            }

            this.showDeleteConfirmation(`Deseja realmente excluir a cota para o exame
                <strong>${ item.nome }</strong>?`,
                destroy)
        },
        getCotaAtribuida(cotaExamePeriodo, items, item) {

            if (cotaExamePeriodo.cotaTipoId == this.enums.tipoCota.VALOR) {

                this.saldoAtribuidas = this.formatSumMoney(cotaExamePeriodo.cota) - this.formatSumMoney(item.cotaValor)
                this.saldoAtribuidas = this.formatMoney(this.saldoAtribuidas, 2)
                let valorAgendado = this.formatMoney(parseFloat(items.valorAgendado), 2)

                this.saldoUtilizadas = this.formatSumMoney(item.cotaValor) - this.formatSumMoney(valorAgendado)
                this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 2)
                this.utilizadas = this.formatMoney(parseFloat(items.valorAgendado), 2)
            } else {

                this.saldoAtribuidas = cotaExamePeriodo.cota - Number(item.cotaQuantidade)
                this.saldoAtribuidas = this.formatMoney(this.saldoAtribuidas, 0)
                this.utilizadas = items.quantidadeAgendada
                this.saldoUtilizadas = item.cotaQuantidade - Number(this.utilizadas)
                this.saldoUtilizadas = this.formatMoney(this.saldoUtilizadas, 0)
            }
        },
        getUtilizada(item) {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let valorUtilizado = this.formatSumMoney(item.valorUtilizado)

                return this.formatMoney(valorUtilizado, 2)
            } else {

                return  this.formatMoney(Number(item.quantidadeUtilizada), 0)
            }
        },
        getSaldo(item) {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cota = this.formatMoney(item.cota, 2)
                let valorUtilizado = this.formatSumMoney(item.valorUtilizado)
                const saldo = this.formatSumMoney(cota) - valorUtilizado

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                return  this.formatMoney(item.cota - Number(item.quantidadeUtilizada), 0)
            }
        },
        getCotaADistribuir(item) {

            let cotasAtribuidas = 0

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let cota = this.formatMoney(item.cota, 2)
                cotasAtribuidas = this.handleCotaAtribuida(item)

                let saldoAtribuidas = this.formatSumMoney(cota) - this.formatSumMoney(cotasAtribuidas)
                return this.formatMoney(saldoAtribuidas, 2)
            } else {

                let cota = this.formatMoney(item.cota, 0)
                let atribuida = this.formatMoney(this.handleCotaAtribuida(item))
                let saldoAtribuidas = this.formatSumMoney(cota) - this.formatSumMoney(atribuida)
                return this.formatMoney(saldoAtribuidas, 0)
            }
        },
        handleCotaAtribuida(item) {

            let cotaAtribuida = 0

            cotaAtribuida = item.unidadeSolicitante
                .reduce((sum, element) => {

                    if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                        if (element.cota) {

                            sum = sum + this.formatSumMoney(element.cota);
                        }
                    } else {

                        if (element.cota) {

                            sum = Number(sum) + Number(element.cota);
                        }
                    }

                    return sum
                },0)

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                return this.formatMoney(cotaAtribuida, 2)
            } else {

                return this.formatMoney(cotaAtribuida, 0)
            }
        },
        getUtilizadaTotal() {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let saldo = this.exames.reduce((sum, element) => {

                    if (element.valorUtilizado) {

                        let valorUtilizado = this.formatSumMoney(element.valorUtilizado)

                        sum = sum + valorUtilizado;
                    }

                    return sum;
                },0)

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                let saldo = this.exames.reduce((sum, element) => {

                    if (element.quantidadeUtilizada) {

                        let quantidadeUtilizada = this.formatMoney(element.quantidadeUtilizada, 0)
                        quantidadeUtilizada = this.formatSumMoney(quantidadeUtilizada)

                        sum = sum + quantidadeUtilizada;
                    }

                    return sum;
                },0)

                return this.formatMoney(parseFloat(saldo), 0)
            }
        },
        getSaldoTotal() {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let saldo = this.exames.reduce((sum, element) => {

                        let valorUtilizado = this.getSaldo(element)
                        valorUtilizado = this.formatSumMoney(valorUtilizado)

                        sum = sum + valorUtilizado;

                    return sum;
                },0)

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                let saldo =  this.exames.reduce((sum, element) => {

                    let quantidadeUtilizada = this.getSaldo(element)
                    quantidadeUtilizada = this.formatSumMoney(quantidadeUtilizada)
                    sum = sum + Number(quantidadeUtilizada);

                    return sum;
                },0)

                return this.formatMoney(saldo, 0)
            }
        },
        getCotaAtribuidaTotal() {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let saldo = this.exames.reduce((sum, element) => {

                        let valor = this.handleCotaAtribuida(element)
                        valor = this.formatSumMoney(valor)

                        sum = sum + valor;

                    return sum;
                },0)

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                let saldo = this.exames.reduce((sum, element) => {

                    let quantidade = this.handleCotaAtribuida(element)
                    quantidade = this.formatSumMoney(quantidade)

                    sum = sum + Number(quantidade);

                    return sum;
                },0)

                return this.formatMoney(parseFloat(saldo), 0)
            }
        },
        getCotaADistribuirTotal() {

            if (this.cotaTipoId == this.enums.tipoCota.VALOR) {

                let saldo = this.exames.reduce((sum, element) => {

                        let valor = this.getCotaADistribuir(element)
                        valor = this.formatSumMoney(valor)

                        sum = sum + valor;

                    return sum;
                },0)

                return this.formatMoney(parseFloat(saldo), 2)
            } else {

                let saldo = this.exames.reduce((sum, element) => {

                    let quantidade = this.getCotaADistribuir(element)
                    quantidade = this.formatSumMoney(quantidade)

                    sum = sum + Number(quantidade);

                    return sum;
                },0)

                return this.formatMoney(saldo, 0)
            }
        },
        save() {

            this.$emit('save')
        },
        formatQuantidade(item) {

            const cota = item.cota
            return this.cotaTipoId == this.enums.tipoCota.VALOR ? cota : this.formatMoney(Number(cota), 0)
        },
    },
    props: {
        data: { type: Object, required: true },
        exames: { type: Array, required: true },
        cotalaboratorio: { type: Object, required: true },
        examesum: { type: Number, required: true },
        cotaTipoId: { type: Number, required: true },
        indexExame: { type: [Number, String], required: true },
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
    },
    mixins: [repository, object, data, formats],
}
</script>

<style scoped>
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-width {
    width: 100%;
}

</style>